      document.addEventListener('DOMContentLoaded', function () {

	const navbarMenu = document.getElementById('navbar');
	const burgerMenu = document.getElementById('burger');
	const overlayMenu = document.querySelector('.overlay');
	console.log("subddtoogle");
	// Show and Hide Navbar Function
	const toggleMenu = () => {
		navbarMenu.classList.toggle('active');
		overlayMenu.classList.toggle('active');
	};

	// Collapsible Mobile Submenu Function
	const collapseSubMenu = () => {
		navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
		navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
	};

	// Toggle Mobile Submenu Function
	const toggleSubMenu = (e) => {
	
		if (e.target.getAttribute('title') == "data-toggle" && window.innerWidth <= 992) {
			e.preventDefault();
			const menuDropdown = e.target.parentElement;

			// If Dropdown is Expanded, then Collapse It
			if (menuDropdown.classList.contains('active')) {
				collapseSubMenu();
			} else {
				// Collapse Existing Expanded Dropdown
				if (navbarMenu.querySelector('.menu-item-has-children.active')) {
					collapseSubMenu();
				}

				// Expanded the New Dropdown
				menuDropdown.classList.add('active');
				const subMenu = menuDropdown.querySelector('.sub-menu');
				subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
			}
		}
	};

	// Fixed Resize Window Function
	const resizeWindow = () => {
		if (window.innerWidth > 992) {
			if (navbarMenu.classList.contains('active')) {
				toggleMenu();
			}
			if (navbarMenu.querySelector('.menu-item-has-children.active')) {
				collapseSubMenu();
			}
		}
	};

	// Initialize Event Listeners
	burgerMenu.addEventListener('click', toggleMenu);
	overlayMenu.addEventListener('click', toggleMenu);
	navbarMenu.addEventListener('click', toggleSubMenu);
	window.addEventListener('resize', resizeWindow);
});